


















interface LocalProps {
  value: PropOptions;
  group: PropOptions;
  name: PropOptions;
  disabled: PropOptions;
}

import Vue, { PropOptions } from 'vue';
export default Vue.extend({
  name: 'HMRadio',
  props: {
    value: {
      default: true,
      required: true,
    },
    group: {
      type: String,
      default: 'radio',
      required: true,
    },
    name: {
      type: [String, Number, Boolean],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
  } as LocalProps,
  computed: {
    checked(): boolean {
      return this.value === this.name;
    },
  },
});
